export const DEFAULT_NOTIFICATIONS_SETTINGS = {
  all: true,
  likes: true,
  comments: true,
  chat: false,
  follow: true,
};
